import { Component } from '@angular/core';
import { ILottieConfig } from '../lottie/lottie-config';
import { FormGroup } from '@angular/forms';
import { InputForm, InputInterface } from 'src/app/classes/input';
import { UserNeedService } from 'src/app/classes/services/user-need.service';
import { ToastrService } from 'ngx-toastr';
import { GiftInter } from 'src/app/classes/interfaces/gift-Inter';
import { AppComponent } from 'src/app/app.component';

const formDataInit: GiftInter = {
  id: 0,
  firstName: '',
  lastName: '',
  phoneNumber: '',
  email: '',
  orderID: 0,
  isActive: true,
  userWant: 1,
  urlUserNeed: ''
};

@Component({
  selector: 'app-counseling-needs-banner',
  templateUrl: './counseling-needs-banner.component.html',
  styleUrls: ['./counseling-needs-banner.component.scss']
})
export class CounselingNeedsBannerComponent {

  lottieConfig: ILottieConfig = {
    width: '100%',
    max_w: '320px',
    height: 'auto',
    path: 'assets/lottie/banner.json',
  };

  lottieConfig2: ILottieConfig = {
    width: '100%',
    max_w: '320px',
    height: 'auto',
    path: 'assets/lottie/click-here.json',
  };

  formControlInit: InputInterface[] = [
    {
      id: 1,
      label: 'نام',
      name: 'firstName',
      class: 'input-without-icon',
      typeofVlaue: 'string',
      placeholder: 'نام',
      required: false,
      hasErr: false,
      height: 2.5,
      width: 0
    },
    {
      id: 3,
      label: 'نام خانوادگی',
      name: 'lastName',
      typeofVlaue: 'string',
      class: 'input-with-icon',
      required: false,
      placeholder: 'نام خانوادگی',
      hasErr: false,
      height: 2.5,
      width: 0
    },
    {
      id: 2,
      label: 'شماره تماس',
      name: 'phoneNumber',
      type: 'pattern',
      class: 'input-without-icon',
      typeofVlaue: 'string',
      placeholder: 'شماره تماس',
      required: true,
      hasErr: false,
      height: 2.5,
      width: 0
    },
  ];

  formControls!: InputInterface[];
  form: FormGroup;
  formMaker = new InputForm(this.formControlInit);

  // =====[انیمیشن]====
  animation = false;

  // =====[OTP]====
  otpStep = false;
  otpCode = '';
  otpSending = false;
  otpCooldown = 0;
  otpCooldownTimer: any;

  startOtpCooldown(seconds: number = 60) {
    this.otpCooldown = seconds;
  
    clearInterval(this.otpCooldownTimer);
  
    this.otpCooldownTimer = setInterval(() => {
      this.otpCooldown--;
  
      if (this.otpCooldown <= 0) {
        clearInterval(this.otpCooldownTimer);
        this.otpCooldownTimer = null;
      }
    }, 1000);
  }

  activeAnimation() {
    this.animation = true;
  }

  deactivateAnimation() {
    this.animation = false;
  }

  constructor(
    private giftFormService: UserNeedService,
    private toaster: ToastrService
  ) {
    this.form = new FormGroup({});

    this.formMaker.inputs.forEach((item) => {
      this.form.setControl(
        item.name,
        this.formMaker.createControl(item)
      );
    });

    this.formControls = this.formMaker.inputs;
  }

  loading = false;

  ngOnInit() {
    if (AppComponent.isBrowser.value) {
      this.loading = true;
    }
  }

  get _firstName(): string {
    return this.form.controls['firstName'].value;
  }

  get _lastName(): string {
    return this.form.controls['lastName'].value;
  }

  get _phoneNumber(): string {
    return this.form.controls['phoneNumber'].value;
  }

  fillOtpValue(value: string) {
    this.otpCode = value
      .replace(/[^0-9]/g, '')
      .slice(0, 4);
  }

  async consultationServices() {
    if (this.otpStep) {
      await this.verifyConsultationOTP();
    } else {
      await this.sendConsultationOTP();
    }
  }

  async sendConsultationOTP() {
    if (this.otpSending) {
      return;
    }

    const formData: GiftInter = {
      ...formDataInit,
      firstName: this._firstName || '',
      lastName: this._lastName || '',
      phoneNumber: this._phoneNumber || '',
      urlUserNeed:
        window.location.pathname +
        window.location.search
    };

    if (!await this.checkFormValidation(formData)) {
      this.toaster.error('خطا در فرم درخواست!!!');
      return;
    }

    try {
      this.otpSending = true;

      const res = await this.giftFormService.sendOTP(
        formData.phoneNumber,
        1,
        0,
        0
      );

      if (res?.success) {
        this.otpStep = true;
        this.otpCode = '';
      
        const isAlreadySent =
          res?.message === 'کد تایید قبلاً برای شما ارسال شده است.';
      
        const cooldownSeconds =
          isAlreadySent
            ? Number(res?.data) || 0
            : 60;
      
        this.startOtpCooldown(cooldownSeconds);
      
        this.giftFormService.toastSuccess(
          res?.message || 'کد تایید با موفقیت ارسال شد.'
        );
      }
      else {
        this.giftFormService.toastError(
          res?.message ||
          'ارسال کد تایید با خطا مواجه شد.'
        );
      }
      
    } catch (error) {
      this.giftFormService.toastError(
        'ارسال کد تایید با خطا مواجه شد.'
      );
    } finally {
      this.otpSending = false;
    }
  }

  async verifyConsultationOTP() {
    if (this.otpCode.length !== 4 || this.otpSending) {
      return;
    }

    try {
      this.otpSending = true;

      const phoneNumber = this._phoneNumber || '';

      const res = await this.giftFormService.verifyOTP(
        phoneNumber,
        1,
        0,
        0,
        Number(this.otpCode)
      );

      if (!res?.success) {
        this.giftFormService.toastError(
          res?.message ||
          'کد تایید وارد شده صحیح نیست.'
        );
        return;
      }

      const formData: GiftInter = {
        ...formDataInit,
        firstName: this._firstName || '',
        lastName: this._lastName || '',
        phoneNumber,
        urlUserNeed:
          window.location.pathname +
          window.location.search
      };

      const createResult =
        await this.giftFormService.consultation_req(
          formData
        );

      if (createResult?.success) {
        this.giftFormService.toastSuccess(
          'درخواست مشاوره با موفقیت ثبت شد.'
        );

        this.form.reset();
        this.otpStep = false;
        this.otpCode = '';

        this.formControls.forEach((x) => {
          const element =
            document.getElementById(x.name) as HTMLInputElement;

          if (element) {
            element.value = '';
          }
        });

        this.animation = false;
      } else {
        this.giftFormService.toastError(
          createResult?.message ||
          'خطا در ثبت درخواست مشاوره.'
        );
      }
    } catch (error) {
      this.giftFormService.toastError(
        'خطا در تایید کد یا ثبت درخواست.'
      );
    } finally {
      this.otpSending = false;
    }
  }

  backToConsultationForm() {
    this.otpStep = false;
    this.otpCode = '';
    this.otpCooldown = 0;
  
    clearInterval(this.otpCooldownTimer);
    this.otpCooldownTimer = null;
  }

  async checkFormValidation(_formData: GiftInter) {
    const formErrors: { [key: string]: string[] } = {};

    for (const controlName in this.form.controls) {
      const control = this.form.controls[controlName];

      if (control.invalid) {
        formErrors[controlName] = [];

        if (control.errors?.['pattern']) {
          formErrors[controlName].push(
            `${controlName} must be a valid number.`
          );
        }
      }
    }

    const erorrKeyName = Object.keys(formErrors);

    this.formControlInit.forEach((x) => {
      if (erorrKeyName.indexOf(x.name) > -1) {
        x.hasErr = true;
      }

      setInterval(() => {
        x.hasErr = false;
      }, 10000);
    });

    if (Object.keys(formErrors).length > 0) {
      return false;
    } else {
      return true;
    }
  }
}